/**
 * Zooming settings for the diagram paper.
 */
export const Zoom = {
    Min: 0.2,
    Max: 2,
    Step: 10
};
